import { Stack, Typography } from "@mui/material";

import { Problem, QuestionType } from "@/types";
import { htmlContentStyles } from "@/utils/htmlContentStyle";
import { renderMathInHtml } from "@/utils/mathRenderer";

import { MultipleChoiceInput, TrueFalseInput, ShortAnswerInput } from "./index";

interface Props {
  problem: Problem;
  answer: string;
  setAnswer: (val: string) => void;
  showSolution: boolean;
  correctAnswer: string;
}

const ProblemAnswerInput = ({
  problem,
  answer,
  setAnswer,
  showSolution,
  correctAnswer,
}: Props) => {
  switch (problem.type) {
    case QuestionType.MultipleChoice:
      return (
        <MultipleChoiceInput
          problem={problem}
          answer={answer}
          setAnswer={setAnswer}
          showSolution={showSolution}
          correctAnswer={correctAnswer}
        />
      );
    case QuestionType.TrueFalse:
      return (
        <TrueFalseInput
          answer={answer}
          setAnswer={setAnswer}
          showSolution={showSolution}
          correctAnswer={correctAnswer}
        />
      );
    case QuestionType.ShortAnswer:
      if (!problem.isApproved) {
        return (
          <Stack>
            <Typography variant="h6">Answer</Typography>
            <Typography
              variant="body1"
              p={2}
              dangerouslySetInnerHTML={{
                __html: renderMathInHtml(problem.correctAnswer, problem.formatVersion),
              }}
              sx={{
                ...htmlContentStyles,
                fontSize: "1rem",
              }}
            />
          </Stack>
        );
      }
      return (
        <ShortAnswerInput
          answer={answer}
          setAnswer={setAnswer}
          showSolution={showSolution}
          points={problem.points}
          score={problem.score}
        />
      );
    default:
      return null;
  }
};

export default ProblemAnswerInput;
